import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { environment } from '@environment';

@Injectable()
export class UserService {
    constructor(private http: HttpClient) {}

    getFullInfo(): Observable<User> {
        return this.http.get<User>(environment.apiInboxUrl + 'users/FullUserInfo');
    }
}
